import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main'



function StatementExpenELe() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Liaison Officers" />
            <section id="services" className="team-area fix p-relative pt-120 pb-80">
            <div className="container">
            <Row>
            <Col md={3} className='c-left custom-padding-color mb-4'>
                  <Committeeleft></Committeeleft>
            </Col>
                
             <Col md={9} className='c-right'>
                       
                    <div className="row">
                
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h3>SC/ST/OBC Liaison Officers/Cell</h3>
                            </div>
                        </div>
                    </div>


                    <div className="row"> 
                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-dark ">
                                <h3><p>Liaison Officer for SC/ST </p></h3>
                                <p>Dr. Bharath Kumar </p>
                                <p>Associate Professor </p>
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i> 0877-2503305 </p>                                
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="bharathk@iittp.ac.in"> bharathk@iittp.ac.in</Link> </p>                                
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-dark ">
                                <h3><p>Liaison Officer for OBC  </p></h3>
                                <p>Dr. N. Venkaiah</p>
                                <p>Associate Professor </p>
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i> 0877-2503035 </p>
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="venkaiah@iittp.ac.in">venkaiah@iittp.ac.in</Link> </p>
                            </div>
                        </div>


                    </div>  {/* Row */}


                    <div className="row mt-4">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h3>SC/ST Cell</h3>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                    <div className="col-lg-6 col-md-6">
                            <div className="services-box text-dark ">
                                <h3><p>Prof. Venkata Ramana Badarla</p></h3>
                                <p>Registrar In-charge </p>                                
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i>  0877-250 3040  </p>
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="registrar@iittp.ac.in"> registrar@iittp.ac.in</Link> </p>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-dark ">
                                <h3><p>Prof. Suresh Jain</p></h3>
                                <p>Professor</p>                                
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i> 0877-250 3166 </p>
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="sureshjain@iittp.ac.in"> sureshjain@iittp.ac.in</Link> </p>
                            </div>
                        </div>
                        </div>  {/* Row */}
                        <div className="row mt-4">
                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-dark ">
                                <h3><p>Prof. Mamilla Ravi Sankar </p></h3>                                
                                <p>Professor </p>
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i> 0877-250 3410  </p>
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="evmrs@iittp.ac.in">evmrs@iittp.ac.in</Link> </p>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="services-box text-dark ">
                                <h3><p>Dr. A. Gowri</p></h3>
                                <p>Associate Professor </p>
                                <p className="text-dark "><i className="fal fa-phone-alt me-2"></i>  0877-2503158   </p>
                                <p className="text-dark text-maroon"><i className="fal fa-envelope  me-2"></i><Link className='text-teal' target="_blank"  to="gowri@iittp.ac.in">gowri@iittp.ac.in</Link> </p>
                            </div>
                        </div>


                    </div>  {/* Row */}


                
                </Col>
            </Row>
            </div>   {/* container */}
            </section>
        </>  
    )
}

export default StatementExpenELe;
